import React, { useEffect } from "react";
import AOS from "aos";
import SEO from "../../SEO";
import "./BarcodeManagementSystem.css";

export default function BarcodeManagementSystem() {
  useEffect(() => {
    AOS.init({ duration: 800, offset: 100, once: true });
  }, []);

  const features = [
    { icon: "📦", text: "Barcode Generation System" },
    { icon: "🏷️", text: "SKU & Product Labeling" },
    { icon: "📡", text: "Real-Time Inventory Sync" },
    { icon: "🛒", text: "POS Integration Support" },
    { icon: "🏬", text: "Multi-Warehouse Support" },
    { icon: "📊", text: "Automated Stock Reports" },
    { icon: "⚡", text: "Fast Scanning System" },
    { icon: "🔐", text: "Secure Data Management" },
  ];

  const benefits = [
    { icon: "💰", text: "Reduce Stock Errors" },
    { icon: "🚀", text: "Faster Billing Process" },
    { icon: "📈", text: "Improve Inventory Accuracy" },
    { icon: "🧠", text: "Smart Business Decisions" },
    { icon: "⚙️", text: "Automation Ready System" },
    { icon: "🏆", text: "Enterprise Level Scalability" },
  ];

  const industries = [
    { icon: "💊", text: "Pharmacy Barcode System" },
    { icon: "🛒", text: "Retail Stores" },
    { icon: "🏪", text: "Supermarkets" },
    { icon: "🏭", text: "Warehouses" },
    { icon: "🍔", text: "Restaurants Inventory" },
    { icon: "👕", text: "Garments Industry" },
    { icon: "🚚", text: "Distribution Companies" },
    { icon: "🛍️", text: "E-Commerce Stores" },
  ];

  const faqs = [
    {
      q: "What is a barcode management system?",
      a: "It is a system that generates and manages barcode labels for products to improve inventory tracking and billing accuracy.",
    },
    {
      q: "Does it work with POS systems?",
      a: "Yes, it integrates seamlessly with POS and ERP systems.",
    },
    {
      q: "Can it manage multiple warehouses?",
      a: "Yes, it supports multi-warehouse and multi-branch inventory management.",
    },
    {
      q: "Is it suitable for retail and pharmacy?",
      a: "Yes, it is widely used in retail, pharmacy, and warehouse businesses.",
    },
  ];

  return (
    <>
      <SEO
        title="Barcode Management System | POS & Inventory Software Pakistan"
        description="Advanced barcode management system for retail, pharmacy, ERP and inventory tracking with POS integration in Pakistan."
        url="https://mzrsoftware.com/barcode-management-system"
      />

      <div className="barcode-section">
        {/* HERO */}
        <section className="hero text-center" data-aos="fade-up">
          <h1>
            Barcode Management <span>System</span>
          </h1>
          <p>
            Smart barcode generation, inventory tracking, and POS integration
            system for retail, pharmacy, warehouse and ERP automation.
          </p>
        </section>

        {/* INTRODUCTION */}
        <section className="section text-center" data-aos="fade-up">
          <h2>Introduction</h2>
          <p>
            Our Barcode Management System helps businesses automate product
            tracking, reduce manual errors, and improve inventory accuracy with
            real-time scanning and reporting.
          </p>
        </section>

        {/* FEATURES */}
        <section className="section">
          <h2 className="text-center">Features</h2>

          <div className="grid">
            {features.map((f, i) => (
              <div
                className="card"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 50}
              >
                <div className="icon">{f.icon}</div>
                <h3>{f.text}</h3>
              </div>
            ))}
          </div>
        </section>

        {/* BENEFITS */}
        <section className="section">
          <h2 className="text-center">Benefits</h2>

          <div className="grid">
            {benefits.map((b, i) => (
              <div className="card" key={i} data-aos="zoom-in">
                <div className="icon">{b.icon}</div>
                <h3>{b.text}</h3>
              </div>
            ))}
          </div>
        </section>

        {/* SCREENSHOTS */}
        <section className="section text-center">
          <h2>Screenshots</h2>

          <div className="grid">
            <div className="card">📊 Barcode Dashboard</div>
            <div className="card">🏷️ Label Generator</div>
            <div className="card">📦 Inventory Panel</div>
          </div>
        </section>

        {/* INDUSTRIES */}
        <section className="section">
          <h2 className="text-center">Industries</h2>

          <div className="grid">
            {industries.map((ind, i) => (
              <div className="card" key={i}>
                <div className="icon">{ind.icon}</div>
                <h3>{ind.text}</h3>
              </div>
            ))}
          </div>
        </section>

        {/* FAQ */}
        <section className="section">
          <h2 className="text-center">FAQs</h2>

          <div className="grid">
            {faqs.map((faq, i) => (
              <div className="card" key={i}>
                <h3>{faq.q}</h3>
                <p>{faq.a}</p>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="cta text-center" data-aos="fade-up">
          <h2>Upgrade Your Inventory with Barcode System</h2>
          <p>
            Automate your retail, pharmacy, and warehouse operations with smart
            barcode technology integrated with ERP & POS systems.
          </p>

          <a href="/contact" className="btn">
            Get Free Consultation →
          </a>
        </section>
      </div>
    </>
  );
}
